import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { I18nModule } from '@spartacus/core';
import { CustomValidatorService } from '../../../../../../components/form-elements/custom-validator.service';
import { BehaviorSubject } from 'rxjs';
import { Option } from '../../../../../../core/models/option.model';
import { FormErrorsModule } from '@spartacus/storefront';
import { TooltipIconComponent } from '../../../../../../components/tooltip-icon/tooltip-icon.component';
import { CustomUserFormService } from '../../../../organization/administration/components/user/form/user-form.service';
import { B2BUserRole } from '../../../../../../core/enums/b2bUserRoles';
import { CustomB2bUserService } from '../../../../organization/administration/components/user/services/custom-b2b-user.service';

@Component({
  selector: 'form-roles',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormErrorsModule, I18nModule, TooltipIconComponent],
  providers: [CustomB2bUserService],
  templateUrl: './form-roles.component.html',
  styleUrl: './form-roles.component.scss',
})
export class FormRolesComponent implements OnInit {
  @Input() form!: FormGroup;

  getRoleInfo = this.customUserFormService.getRoleInfo;
  availableRoles$ = new BehaviorSubject<Option[]>([]);

  constructor(
    protected fb: FormBuilder,
    protected userService: CustomB2bUserService,
    protected customUserFormService: CustomUserFormService,
    protected customValidatorService: CustomValidatorService,
  ) {}

  ngOnInit(): void {
    this.populateRoles();
  }

  populateRoles() {
    let availableRoles: Option[] = this.userService.getAllRoles().map((role: B2BUserRole) => {
      return {
        code: role,
        label: role,
      };
    });

    availableRoles = availableRoles.filter(role => role.code !== B2BUserRole.SALESREP.toString());
    this.availableRoles$.next(availableRoles);
  }
}
